import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import deviceAxios from '../../../../utils/axios/device.axios';
import { PaginatedHistoryChats } from '../../../../interfaces/history-chats/paginatedStore.type';
import { ICards } from '../../../../interfaces/cards/ICards';

const tryToCreateCards = (data: ICards): Promise<AxiosResponse<any>> => {
    return deviceAxios.post(`${DEVICE_INFO_API_URL}/cards/create`, data);
};
const tryToEditCards = (data: ICards): Promise<AxiosResponse<any>> => {
    return deviceAxios.patch(`${DEVICE_INFO_API_URL}/cards/${data._id}`, data);
};

const tryToFetchCards = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/cards`);
};

const tryToDeleteCards = (id: string): Promise<AxiosResponse<any>> => {
    return deviceAxios.delete(`${DEVICE_INFO_API_URL}/cards/${id}`);
};

const tryToFetchHistoryChats = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedHistoryChats>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/chatbox/user-management-topics/all?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/chatbox/user-management-topics/all?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<PaginatedHistoryChats>(url, { filters: data });
};

const tryToFetchSingleChat = (topicId: string): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(
        `${DEVICE_INFO_API_URL}/chatbox/user-management/chats/all/${topicId}`,
    );
};

const tryToAddActionForChat = (
    id: string,
    data: any,
): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(
        `${DEVICE_INFO_API_URL}/chatbox/messages/${id}/reaction`,
        data,
    );
};

export const HistoryChatsService = {
    tryToFetchHistoryChats,
    tryToFetchSingleChat,
    tryToAddActionForChat,
    tryToCreateCards,
	tryToEditCards,
    tryToFetchCards,
    tryToDeleteCards,
};
